import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import { AuthProvider } from "./contexts/AuthContext"
import Header from "./components/Header"
import Footer from "./components/Footer"
import ScrollToTop from "./components/ScrollToTop"
import HomePage from "./pages/HomePage"
import NominationPage from "./pages/NominationPage"
import ServiceRequestPage from "./pages/ServiceRequestPage"
import PharmacyFirstPage from "./pages/PharmacyFirstPage"
import WeightLossClinicPage from "./pages/WeightLossClinicPage"
import FluVaccinationPage from "./pages/FluVaccinationPage"
import NewMedicineClinicPage from "./pages/NewMedicineClinicPage"
import ContraceptionPage from "./pages/ContraceptionPage"
import PrivatePrescriptionsPage from "./pages/PrivatePrescriptionsPage"
import HypertensionPage from "./pages/HypertensionPage"
import AmendAppointmentPage from "./pages/AmendAppointmentPage"
import AdminLoginPage from "./pages/admin/AdminLoginPage"
import AdminDashboardPage from "./pages/admin/AdminDashboardPage"
import SetPasswordPage from "./pages/admin/SetPasswordPage"
import ProtectedRoute from "./components/admin/ProtectedRoute"
import "./App.css"

function App() {
  return (
    <AuthProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          {/* Admin Routes (no header/footer) */}
          <Route path="/admin/login" element={<AdminLoginPage />} />
          <Route path="/admin/set-password" element={<SetPasswordPage />} />
          <Route
            path="/admin/dashboard"
            element={
              <ProtectedRoute>
                <AdminDashboardPage />
              </ProtectedRoute>
            }
          />

          {/* Public Routes (with header/footer) */}
          <Route
            path="/*"
            element={
              <div className="app">
                <Header />
                <main className="main-content">
                  <Routes>
                    <Route path="/" element={<HomePage />} />
                    <Route path="/nominate" element={<NominationPage />} />
                    <Route path="/services" element={<ServiceRequestPage />} />
                    <Route path="/pharmacy-first" element={<PharmacyFirstPage />} />
                    <Route path="/weight-loss" element={<WeightLossClinicPage />} />
                    <Route path="/flu-vaccination" element={<FluVaccinationPage />} />
                    <Route path="/new-medicine-clinic" element={<NewMedicineClinicPage />} />
                    <Route path="/contraception" element={<ContraceptionPage />} />
                    <Route path="/private-prescriptions" element={<PrivatePrescriptionsPage />} />
                    <Route path="/hypertension" element={<HypertensionPage />} />
                    <Route path="/amend/appointment/:token" element={<AmendAppointmentPage />} />
                  </Routes>
                </main>
                <Footer />
              </div>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  )
}

export default App
